import React from 'react'
import styled from '@emotion/styled'
import Triangle from './ExclamationTriangle'
import { fontWeightRegular, fontSize2XSmall, grayBase, goldLight10, fontWeightSemibold, fontFamilyOpenSans } from '../../constants/principles'

export default ({ title, text, leftAlign, testId }) => (
  <>
    <Warning leftAlign={leftAlign} indent={0} data-testid= {`${testId}-title`}>
      <SpacedSpan>
        <Triangle colorFill={goldLight10} width={16} height={16} />
      </SpacedSpan>
      {title}
    </Warning>
    <Warning data-testid= {`${testId}-desc`} fontWeight={fontWeightRegular} indent={p => (p.leftAlign ? 24 : 0)} leftAlign={leftAlign}>
      {text}
    </Warning>
  </>
)

const SpacedSpan = styled.span`
  height: 16px;
  padding-right: 8px;
  display: flex;
  margin-top: 4px;
`
const Warning = styled.p`
  font-size: ${fontSize2XSmall};
  font-weight: ${p => (p.fontWeight ? p.fontWeight : fontWeightSemibold)};
  font-family: ${fontFamilyOpenSans};
  color: ${grayBase};
  display: flex;
  justify-content: ${p => (p.leftAlign ? 'flex-start' : 'center')};
  text-align: ${p => (p.leftAlign ? 'left' : 'center')};
  width: ${p => (p.leftAlign ? 100 : 90)}%;
  margin: 8px 0;
  padding-left: ${p => p.indent}px;
`
